import { generateCarleadCreationConfig } from '@wkda/funnel-utils';
import { DEFAULT_CARLEAD_CONFIGS } from '@wkda/marketing-components';

const extendedCarleadCreationConfig = {
  ...DEFAULT_CARLEAD_CONFIGS['sv-SE'],
  step2Path: '/{currentPath}/step-2/',
};

export default generateCarleadCreationConfig(extendedCarleadCreationConfig);

